(function () {
  if (customElements.get('set-cart-line')) return;

  let denetimZamanlayici = null;
  let kontrolEdiliyor = false;

  function oku(el) {
    let dist = [];
    let hucreler = [];
    try {
      dist = JSON.parse(el.getAttribute('data-set-dist') || '[]');
      hucreler = JSON.parse(el.getAttribute('data-set-hucreler') || '[]');
    } catch (e) {
      dist = [];
      hucreler = [];
    }
    const esik = parseInt(el.getAttribute('data-set-esik')) || 0;
    return { dist, hucreler, esik };
  }

  function durumHesapla(el) {
    const D = window.SetDagitim;
    const veri = oku(el);
    if (!D || !veri.dist.length) return null;
    const sonuc = D.sepetDurumu(veri.dist, veri.hucreler, veri.esik);
    if (el.hasAttribute('data-set-gecersiz')) sonuc.gecerli = false;
    return Object.assign({}, veri, sonuc);
  }

  function odemeGoster(goster) {
    document.querySelectorAll('[data-set-odeme]').forEach((dugme) => {
      dugme.hidden = !goster;
    });
    document.querySelectorAll('[data-set-odeme-uyari]').forEach((not) => {
      not.hidden = goster;
    });
  }

  function tumunuDenetle() {
    const satirlar = Array.from(document.querySelectorAll('set-cart-line'));
    odemeGoster(!satirlar.some((satir) => satir.gecerli === false));
  }

  function denetimPlanla() {
    clearTimeout(denetimZamanlayici);
    denetimZamanlayici = setTimeout(tumunuDenetle, 0);
  }

  function odemeyeGit() {
    window.location.href = theme.routes.cart_url + '?view=odeme';
  }

  function tazeKontrol(dugme) {
    const kap = dugme.closest('cart-drawer, main-cart');
    if (!kap) return Promise.resolve(!Array.from(document.querySelectorAll('set-cart-line')).some((satir) => satir.gecerli === false));

    const id = kap.getAttribute('data-section-id');
    const sayfa = kap.tagName.toLowerCase() === 'main-cart';
    const adres = `${sayfa ? theme.routes.cart_url : theme.routes.root_url}?section_id=${encodeURIComponent(id)}`;

    return fetch(adres, { headers: { Accept: 'text/html' }, cache: 'no-store' })
      .then((yanit) => {
        if (!yanit.ok) throw new Error('kontrol');
        return yanit.text();
      })
      .then((html) => {
        const belge = new DOMParser().parseFromString(html, 'text/html');
        const satirlar = Array.from(belge.querySelectorAll('set-cart-line'));
        let gecerli = satirlar.every((satir) => {
          const durum = durumHesapla(satir);
          return !!(durum && durum.gecerli);
        });
        if (gecerli && satirlar.length && !belge.querySelector('[data-set-odeme]')) gecerli = false;
        if (!gecerli) {
          const hedefId = `${sayfa ? 'MainCart' : 'MiniCart'}-${id}`;
          const yeni = belge.getElementById(hedefId);
          const eski = document.getElementById(hedefId);
          if (yeni && eski) eski.innerHTML = yeni.innerHTML;
        }
        return gecerli;
      });
  }

  document.addEventListener(
    'click',
    (event) => {
      const dugme = event.target && event.target.closest ? event.target.closest('[data-set-odeme]') : null;
      if (!dugme) return;
      if (!document.querySelector('set-cart-line')) {
        event.preventDefault();
        odemeyeGit();
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (kontrolEdiliyor) return;
      kontrolEdiliyor = true;
      dugme.setAttribute('aria-busy', 'true');
      tazeKontrol(dugme)
        .then((gecerli) => {
          if (gecerli) odemeyeGit();
        })
        .catch(() => {
          document.querySelectorAll('[data-set-odeme-uyari]').forEach((not) => {
            not.textContent = 'Sepet doğrulanamadı. Sayfayı yenileyip tekrar deneyin.';
            not.hidden = false;
          });
        })
        .finally(() => {
          kontrolEdiliyor = false;
          dugme.removeAttribute('aria-busy');
        });
    },
    true
  );

  class SetCartLine extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[data-set-sets]');
      this.uyari = this.querySelector('[data-set-uyari]');
      this.durum = durumHesapla(this);
      this.gecerli = !!(this.durum && this.durum.gecerli);
      this.busy = false;

      this.addEventListener('change', this.onChange.bind(this));
      this.querySelectorAll('[data-set-remove]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          this.update(0);
        });
      });
      this.querySelectorAll('[data-set-duzelt]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          this.update(this.durum ? this.durum.onerilen : 0);
        });
      });

      this.uyariGoster();
      denetimPlanla();
    }

    disconnectedCallback() {
      denetimPlanla();
    }

    uyariGoster() {
      if (!this.uyari) return;
      this.uyari.hidden = this.gecerli;
      if (this.gecerli) return;
      const metin = this.uyari.querySelector('[data-set-uyari-metin]');
      const dugme = this.uyari.querySelector('[data-set-duzelt]');
      if (!this.durum) {
        if (metin) metin.textContent = 'Set bilgisi yüklenemedi. Sayfayı yenileyin.';
        if (dugme) dugme.hidden = true;
        return;
      }
      if (this.durum.onerilen < 1) {
        if (metin) metin.textContent = 'Bu ürün tükendi.';
        if (dugme) dugme.textContent = 'Sepetten çıkar';
      } else {
        if (metin) metin.textContent = 'Stok değişti, set dağılımınız güncellenmeli.';
        if (dugme) dugme.textContent = 'Sepeti düzelt';
      }
    }

    onChange(event) {
      if (!this.input || event.target !== this.input) return;
      event.stopPropagation();
      let sets = parseInt(this.input.value);
      if (isNaN(sets) || sets < 0) sets = 0;
      this.update(sets);
    }

    update(sets) {
      const D = window.SetDagitim;
      const durum = this.durum;
      if (this.busy) return;
      if (!D || !durum) {
        this.fail('Set bilgisi yüklenemedi. Sayfayı yenileyin.');
        return;
      }

      let adet = Math.max(0, Math.floor(Number(sets) || 0));
      if (durum.enFazla < D.SINIRSIZ && adet > durum.enFazla) adet = durum.enFazla;

      const hedef = D.toplam(durum.dist, durum.stok, adet);
      if (!hedef) {
        this.fail('Set dağılımı hesaplanamadı. Sayfayı yenileyin.');
        return;
      }

      const updates = {};
      durum.hucreler.forEach((hucre) => {
        if (!hucre.id) return;
        const yeni = hedef[hucre.k] || 0;
        if (yeni > 0 || (hucre.adet || 0) > 0) updates[hucre.id] = yeni;
      });
      if (!Object.keys(updates).length) return;

      this.busy = true;
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

      const cartItems = this.closest('cart-items');
      if (cartItems) cartItems.classList.add('pointer-events-none');
      this.setAttribute('aria-busy', 'true');
      const loader = this.querySelector('[data-set-loader]');
      if (loader) loader.hidden = false;

      fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), body: JSON.stringify({ updates, sections: sections.join(',') }) })
        .then((response) => response.json())
        .then((parsed) => {
          if (parsed.status) {
            this.fail(parsed.description || parsed.message || (theme.cartStrings && theme.cartStrings.error) || 'Sepet güncellenemedi');
            return;
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsed });
        })
        .catch(() => {
          this.fail((theme.cartStrings && theme.cartStrings.error) || 'Sepet güncellenemedi');
        })
        .finally(() => {
          this.busy = false;
        });
    }

    fail(message) {
      const cartItems = this.closest('cart-items');
      if (cartItems) cartItems.classList.remove('pointer-events-none');
      this.removeAttribute('aria-busy');
      const loader = this.querySelector('[data-set-loader]');
      if (loader) loader.hidden = true;
      if (this.input) this.input.value = this.input.defaultValue;
      const node = this.querySelector('[data-set-error]');
      if (node) {
        node.textContent = message;
        node.hidden = false;
      }
    }
  }

  customElements.define('set-cart-line', SetCartLine);
})();
